import {ComponentService} from "./service/component";
import {Application} from "./application/application";
import {CarouselComponent} from "./components/carousel";
import {CarouselMultipleItemsComponent} from "./components/carousel-multiple-items";
import {BannerCarouselComponent} from "./components/banner-carousel";
import {CarouselCaseStudiesComponent} from "./components/carousel-case-studies";
import {CarouselLogoListComponent} from "./components/carousel-logo-list";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {
    let components = new ComponentService();
    components.addComponent('.js-carousel', CarouselComponent, 'CarouselComponent');
    components.addComponent('.js-multi-features-carousel', CarouselMultipleItemsComponent, 'CarouselMultipleItemsComponent');
    components.addComponent('.js-banner-carousel', BannerCarouselComponent, 'BannerCarouselComponent');
    components.addComponent('.js-cards-slider', CarouselCaseStudiesComponent, 'CarouselCaseStudiesComponent');
    components.addComponent('.js-logos-slider', CarouselLogoListComponent, 'CarouselLogoListComponent');
    new Application(components);
}))(jQuery);
